import { ONLY_TRANSACTIONAL_KEY } from '@/constants/state'
import { useMixpanel } from '@/context/mixpanel'
import { useVaultsSearchState } from '@/hooks/useVaultsSearchState'
import { useCallback } from 'react'
import { Switch, type SwitchProps } from '../common/switch'

export function TransactionalFilter(props: SwitchProps) {
  const { onlyTransactional, updateSearchState } = useVaultsSearchState()
  const { trackEvent } = useMixpanel()

  const handleOnlyTransactional = useCallback(() => {
    updateSearchState([ONLY_TRANSACTIONAL_KEY, !onlyTransactional])
    trackEvent('Filter used', {
      Filter: 'transactional',
      Value: !onlyTransactional,
    })
  }, [trackEvent, onlyTransactional, updateSearchState])

  return <Switch checked={onlyTransactional} onCheckedChange={handleOnlyTransactional} {...props} />
}
